import { BuildType } from 'src/enums/build/build-type';

export const getBuildTypesFlags = (buildType: BuildType) => {
  const isMeridian = buildType === BuildType.MERIDIAN;
  const isHarbour = buildType === BuildType.HARBOUR;
  const isTogetherFoundation = buildType === BuildType.TOGETHER_FOUNDATION;
  const isDL =
    buildType !== BuildType.MERIDIAN &&
    buildType !== BuildType.HARBOUR &&
    buildType !== BuildType.TOGETHER_FOUNDATION;

  return { isMeridian, isHarbour, isDL, isTogetherFoundation };
};
